import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../core/auth.service';
import { normalizeText, validateValue } from '../../shared/validation';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, NgIf, RouterLink, MatIconModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  email = 'supervisor@pms.local';
  password = 'Password@123';
  error = '';
  success = '';
  loading = false;
  showPassword = false;

  constructor(private auth: AuthService, private router: Router, private route: ActivatedRoute) {
    this.success = this.route.snapshot.queryParamMap.get('message') || '';
  }

  /**
   * Submits credentials, stores the returned session, and redirects to the dashboard.
   * @returns void.
   */
  submit() {
    this.error = '';
    this.success = '';
    this.email = normalizeText(this.email, true);
    const validationMessage =
      validateValue('Email address', this.email, { required: true, kind: 'email' }) ||
      validateValue('Password', this.password, { required: true, minLength: 1, maxLength: 128 });
    if (validationMessage) {
      this.error = validationMessage;
      return;
    }
    this.loading = true;
    this.auth.login(this.email, this.password).subscribe({
      next: (result) => {
        this.auth.completeLogin(result.token, result.user);
        this.router.navigateByUrl('/dashboard');
      },
      error: (error) => {
        this.error = error.error?.message || 'Login failed';
        this.loading = false;
      }
    });
  }
}
